export enum Civility {
  Mrs = 'MRS',
  Mr = 'MR',
}
